import React from 'react'
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import { v4 as uuidv4 } from "uuid";


const Analytics_faq = () => {
    const webDevelopmentFAQs = [
        {
          "id": uuidv4(),
          "question": "What are AI Solutions, and how do they differ from traditional software?",
          "answer": "AI Solutions use machine learning, natural language processing, and automation to learn from data and improve over time, whereas traditional software follows fixed, pre-programmed rules. This allows AI-powered systems to adapt, predict outcomes, and make intelligent decisions without constant manual updates."
        },
        {
          "id": uuidv4(),
          "question": "How can AI Solutions benefit my organization?",
          "answer": "AI Solutions can offer several advantages, including improved decision-making, enhanced operational efficiency, automation of repetitive tasks, and the ability to uncover hidden patterns in data. It empowers organizations to become more responsive, reduce costs, and drive innovation across every function."
        },
        {
          "id": uuidv4(),
          "question": "What types of business processes can be automated using AI?",
          "answer": "AI can automate a wide range of processes including customer support through chatbots, document and data processing, quality inspection using computer vision, demand forecasting, and routine workflow approvals. This flexibility allows organizations to reduce manual effort and focus on higher-value work."
        },
        {
          "id": uuidv4(),
          "question": "Do I need a technical team to implement and use AI Solutions?",
          "answer": "Many AI Solutions are built with user-friendly interfaces and pre-trained models, enabling teams to adopt them with minimal technical expertise. Our solutions are designed with proper integration, training, and support so that both technical and non-technical users can leverage AI effectively within their existing workflows."
        },
        {
          "id": uuidv4(),
          "question": "What role does predictive analytics play in AI Solutions?",
          "answer": "Predictive analytics uses machine learning models to analyze historical data and forecast future trends, customer behavior, or potential risks. This capability helps organizations anticipate outcomes, plan proactively, and make data-driven strategic decisions ahead of time."
        }
      ]
      return (
        <div className='px-5 sm:px-60 mt-10' id="faq">
          <p className='text-[#333e49] text-center font-notosans text-2xl sm:text-4xl font-bold m-10'>Frequently Asked Questions</p>
          {
            webDevelopmentFAQs.map((item) => 
        <Accordion key={item.id}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
            className='font-notosans font-bold'
          >
            {item.question}
          </AccordionSummary>
          <AccordionDetails className='font-notosans'>
            {item.answer}
          </AccordionDetails>
        </Accordion>
            )
          }
      </div>
      )
}

export default Analytics_faq